import { TERMS_LINKS, termsUrls } from '@avalara/bat-apps-shared/constants';
import { t, translate } from '@avalara/bat-apps-shared/i18n';
import { SAlert } from '@avalara/skylab-sdk/react';

import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { isFormIncomplete } from '../../lib/shared-signup';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { addReturnsOffer } from '../../lib/side-effects/offers';
import { selectState } from '../../selectors';
import ExternalLink from '../external-link';
import { purchaseDeflectionWording } from '../helpers';

const DisclaimerContainer = styled.div`
  padding-top: 20px;
`;

const BuyButtonAndDisclaimer = () => {
  const state = useSelector(selectState);
  const dispatch = useAppDispatch();
  const history = useHistory();

  const {
    account: { accountId, isAdmin, selectedPaymentMethod, isLoggedIn },
  } = state;

  const onSubmit = () => {
    dispatch(updateProductAnalytics('buy_now'));
    if (accountId != null && selectedPaymentMethod != null) {
      dispatch(
        addReturnsOffer({
          history,
          paymentToken: selectedPaymentMethod.Id,
          successPage: '/returns/thank-you',
        }),
      );
    }
  };

  const disabled =
    (isFormIncomplete(state.sharedSignup) && state.account.accountId === null) || (isLoggedIn && isAdmin === false);

  return (
    <DisclaimerContainer>
      {selectedPaymentMethod && (
        <button
          id='submit-payment'
          type='button'
          data-ref='buy.returns-disclaimer.submit-button'
          className='primary'
          disabled={disabled}
          onClick={disabled ? undefined : onSubmit}
        >
          {t('client.buttons.buy-now')}
        </button>
      )}
      {isLoggedIn && isAdmin === false ? (
        <SAlert className='margin-top-sm' status='warning' noDismiss>
          <div data-ref='buy.returns-disclaimer.purchase-deflection'>{purchaseDeflectionWording}</div>
        </SAlert>
      ) : (
        <Fragment>
          <p className='pad-top-sm'>
            {translate('client.returns.buy-button-and-disclaimer.agreement-terms', {
              buttonLabel: !selectedPaymentMethod ? 'Finish' : t('client.buttons.buy-now'),
              buttonText: (chunks) => <span className='font-bold'>{chunks}</span>,
              lineBreak: <br />,
              termsLink: (chunks) => (
                <ExternalLink
                  data-ref='buy.returns-disclaimer.terms-conditions.link'
                  href={TERMS_LINKS.general}
                  alwaysOpenInNewTab
                >
                  {chunks}
                </ExternalLink>
              ),
              termsLabel: t('client.general.avalara-service-terms-and-conditions-1'),
            })}
          </p>
          <div>
            <p data-ref='buy.returns-disclaimer.payment-text' className='pad-top-sm'>
              {translate('client.returns.buy-button-and-disclaimer.cancellation-terms', {
                cancellationUrl: termsUrls.cancellation,
                cancellationLink: (chunks) => (
                  <a href={termsUrls.cancellation} target='_blank' rel='noopener noreferrer'>
                    {chunks}
                  </a>
                ),
              })}
            </p>
            <p data-ref='buy.returns-disclaimer.authorization-text' className='pad-top-sm'>
              {t('client.billing-terms.second-sentence')}
            </p>
          </div>
        </Fragment>
      )}
    </DisclaimerContainer>
  );
};

export default BuyButtonAndDisclaimer;
